// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2g84d","title":"styles_title__S_VO1","text":"styles_text__e_64T"};